module.exports = __webpack_public_path__ + "img/pk.c02a9989.svg";